import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@core/layout/header/header.component';
import { SidebarComponent } from '@core/layout/sidebar/sidebar.component';
import { SidebarModule } from '@core/layout/sidebar/sidebar.module';

@Component({
    selector: 'pn-page',
    standalone: true,
    imports: [CommonModule, RouterOutlet, SidebarModule, MatDividerModule, HeaderComponent],
    template: `
        <div class="flex h-svh flex-row bg-zinc-50 mb:relative mb:w-full">
            <pn-sidebar />
            <div class="h-full w-[0.5px] shrink-0 bg-neutral-03"></div>
            <section class="grow mb:w-full">
                <pn-header (openMenu)="handleOpenMenu()" />
                <main
                    class="flex h-[calc(100%-109px)] flex-col overflow-y-auto overflow-x-hidden mb:h-[calc(100%-50px)] mb:w-full mb:!p-0"
                >
                    <div class="grow">
                        <router-outlet></router-outlet>
                    </div>
                    <div
                        class="flex h-[30px] w-full shrink-0 flex-row items-center justify-between border-t border-t-neutral-03 bg-neutral-01 px-6 mb:hidden"
                    >
                        <p class="leading-4.5 text-xs font-normal text-neutral-06">
                            © Copyright {{ currentYear }}
                            <span class="mx-1 font-bold">bay68.vn</span>
                            , Inc. All rights reserved
                        </p>
                        <p class="leading-4.5 text-xs font-normal text-neutral-06">
                            <span class="mr-1 font-bold">Booking CMS</span>
                            ver. 1.0.6
                        </p>
                    </div>
                </main>
            </section>
        </div>
    `,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {
    public currentYear: number = new Date().getFullYear();
    public sidebar = viewChild(SidebarComponent);

    /**
     * Handle open mobile menu
     *
     * @memberof ManagesComponent
     */
    public handleOpenMenu(): void {
        this.sidebar()?.sidebarVisible.set(true);
    }
}
